import { useQuery } from '@apollo/client/react'

import { GetMainSidebarInfo } from '~publish/components/MainSidebar/components/ChannelsSection/useChannels'
import { sanitizeNullableArray } from '~publish/helpers/typeGuards'
import { getPublishAccessScope } from '~publish/utils/permissions/viewOnlyPublish'
import type { PublishAccessScope } from '~publish/utils/permissions/viewOnlyPublish'

/**
 * The actor's org-wide Publish access scope, derived from the channels query
 * the sidebar keeps warm (cache-first, so no extra fetch on the surfaces that
 * render alongside it). Locked channels are excluded to match the Publish
 * surfaces, which only list unlocked channels.
 *
 * Returns `'none'` until the query resolves; callers treat that as "show
 * nothing", so the coach marks never flash before access is known.
 */
export const usePublishAccessScope = (): PublishAccessScope => {
  const { data } = useQuery(GetMainSidebarInfo, { fetchPolicy: 'cache-first' })
  const channels = sanitizeNullableArray(
    data?.account?.currentOrganization?.channels,
  )

  return getPublishAccessScope(channels.filter((channel) => !channel.isLocked))
}
